import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import useUpload from 'hooks/useUpload';
import { toast } from 'react-toastify';
import IconButton from 'components/common/IconButton';
import AddImageModal from './AddImageModal';
import { useUpdateDonor } from 'hooks/useDonors';
import SendDonorEmailModal from './SendDonorEmailModal';

const ProfileCard = ({ donorData }) => {
  const { first_name, last_name, title, image, type, simple_id, id } =
    donorData || {};
  const fullName = `${first_name} ${last_name}`;

  const { upload, loading: uploadLoading } = useUpload();
  const [addImageShow, setAddImageShow] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const { updateDonorAsync } = useUpdateDonor();

  const onSubmit = async values => {
    try {
      if (values.image && typeof values.image !== 'string') {
        const profileUrl = await upload(values.image);
        values.image = profileUrl;

        await updateDonorAsync({
          id,
          data: {
            image: values.image
          }
        });

        toast.success('Image Added Successfully');
        setAddImageShow(false);
      }
    } catch (error) {
      toast.error('Something went wrong! Please Try again later!');
      return;
    }
  };

  return (
    <Card className="border rounded-3 bg-white dark__bg-1000 shadow-none">
      <Card.Body className="row g-0 flex-column flex-sm-row flex-xl-column z-index-1 align-items-center">
        <Flex justifyContent="between" alignItems="center" className={'mb-3'}>
          <h6 className="mb-0" style={{ fontSize: '1rem' }}>
            Donor Account
          </h6>
          <SoftBadge pill bg="primary" className="align-self-center fs--2">
            <FontAwesomeIcon icon="user" className="me-1" /> {type}
          </SoftBadge>
        </Flex>
        <div className="text-center">
          <Flex justifyContent="center" alignItems="end">
            {' '}
            <div
              onClick={() => setAddImageShow(true)}
              style={{ cursor: 'pointer' }}
              role="button"
              tabIndex={0}
              onKeyDown={e => e.key === 'Enter' && setAddImageShow(true)}
            >
              <Avatar
                src={image}
                name={fullName}
                rounded="circle"
                size="4xl"
                className="border border-5 border-white rounded-circle shadow-sm mb-2"
              />
            </div>
            <IconButton
              icon="pen"
              variant="falcon-default"
              className="bg-transparent shadow-none"
              onClick={() => {
                setAddImageShow(true);
              }}
              style={{ padding: 0 }}
            />
          </Flex>

          {addImageShow && (
            <AddImageModal
              show={addImageShow}
              onSubmit={onSubmit}
              onHide={() => {
                setAddImageShow(false);
              }}
              loading={uploadLoading}
              title={'Add Photo'}
            />
          )}

          <p
            className="mb-1 text-primary fw-medium"
            style={{ fontSize: '1rem' }}
          >
            {title}.{fullName}
          </p>
          <p className="mb-0 text-700 font-base" style={{ fontSize: '1rem' }}>
            ID: {simple_id}
          </p>
          <IconButton
            icon="envelope"
            variant="falcon-default"
            size="sm"
            className="mt-3"
            onClick={() => setShowEmailModal(true)}
          >
            <span className="ms-1">Send email</span>
          </IconButton>
          {showEmailModal && (
            <SendDonorEmailModal
              show={showEmailModal}
              onHide={() => setShowEmailModal(false)}
              donor={donorData}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

ProfileCard.propTypes = {
  donorData: PropTypes.object
};

export default ProfileCard;
